import { notification } from "antd";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { getLimits, getLimitsFailure, getLimitsSuccess } from "./action.js";
import {
  GET_LIMITS_REQUEST,
  STATUS_CONFIG_LOADER_START,
  STATUS_CONFIG_LOADER_STOP,
  UPDATE_LIMITS_REQUEST,
} from "./types.js";
import { ADMIN_URL } from "../../config.js";
import fetch from "../../services/fetch.js";
import { GET_PROJECT_REQUEST } from "../data360Live_Project/types.js";

function* getLimitsSaga(action) {
  try {
    yield put({ type: STATUS_CONFIG_LOADER_START });

    const { project_number } = action.payload;

    const url = `${ADMIN_URL}/v1/limits/get-limits?project_id=${project_number}`;

    const res = yield fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (res.status === 403) {
      yield put({ type: STATUS_CONFIG_LOADER_STOP });
      throw new Error("Unauthorized");
    }
    const response = yield res.json();

    if (res.status === 200) {
      if (response.data) {
        yield put(getLimitsSuccess(response.data));
        yield put({ type: STATUS_CONFIG_LOADER_STOP });
        return;
      }
    }

    if (response.status === 410) {
      yield put(getLimitsFailure(response.message));
      yield put({ type: STATUS_CONFIG_LOADER_STOP });
      notification.warn({
        message: response.message || "Resource not found",
        duration: 6,
      });
    } else {
      yield put(getLimitsFailure(response.message || "Something went wrong"));
      yield put({ type: STATUS_CONFIG_LOADER_STOP });
      notification.error({
        message: response.message || "Something went wrong",
      });
    }
  } catch (error) {
    console.error("Error in getLimitsSaga:", error);
    yield put(getLimitsFailure(error.message));
    notification.error({
      message: error.message || "Something went wrong",
    });
  } finally {
    yield put({ type: STATUS_CONFIG_LOADER_STOP });
  }
}

function* updateLimitsSaga(action) {
  try {
    yield put({ type: STATUS_CONFIG_LOADER_START });

    const { project_id, project_name, payload } = action.payload;

    const url = `${ADMIN_URL}/v1/limits/edit-status-configuration?project_id=${project_id}`;

    const res = yield fetch(url, {
      method: "PUT",
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        payload: payload,
      }),
    });

    if (res.status === 403) {
      yield put({ type: STATUS_CONFIG_LOADER_STOP });
      throw new Error("Unauthorized");
    }
    const response = yield res.json();

    if (res.status === 200) {
      if (response.data.status === "Success") {
        yield put(getLimits({ project_number: project_id, project_name }));
        yield put({ type: STATUS_CONFIG_LOADER_STOP });
        yield put({ type: GET_PROJECT_REQUEST });
        return;
      }
    }

    if (response.status === 410) {
      yield put(getLimitsFailure(response.message));
      yield put({ type: STATUS_CONFIG_LOADER_STOP });
      notification.warn({
        message: response.message || "Resource not found",
        duration: 6,
      });
    } else {
      yield put(getLimitsFailure(response.message || "Something went wrong"));
      yield put({ type: STATUS_CONFIG_LOADER_STOP });
      notification.error({
        message: response.message || "Something went wrong",
      });
    }
  } catch (error) {
    console.error("Error in getLimitsSaga:", error);
    yield put(getLimitsFailure(error.message));
    notification.error({
      message: error.message || "Something went wrong",
    });
  } finally {
    yield put({ type: STATUS_CONFIG_LOADER_STOP });
  }
}

function* statusConfigWatcher() {
  yield takeLatest(GET_LIMITS_REQUEST, getLimitsSaga);
  yield takeLatest(UPDATE_LIMITS_REQUEST, updateLimitsSaga);
}

export default function* statusConfigSagas() {
  yield all([call(statusConfigWatcher)]);
}
